import React, { useState, useEffect } from 'react';

import { useRecoilState } from 'recoil';
import { tokenAtom } from 'core/config/atoms';

import { ScrollArea } from "@/components/ui/scroll-area";

import Lottie from 'lottie-react';
import { toast } from 'react-toastify';
import axios from 'axios';
import { Controlled as ControlledZoom } from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

import TopBar from 'core/widgets/ui/TopBar';

import animBtnLoading from '../../assets/anim/anim-btnLoading.json';
import animPage from '../../assets/anim/anim-pageload.json';

import ServiceMedia from 'services/serviceMedia';

import { API_URL } from 'services/models/AppConstent';

const allowedExtensions = ["png", "jpeg"];

export default function PanelFImage() {
    const [token] = useRecoilState(tokenAtom);

    const [media, setMedia] = useState([]);

    const [upfiles, setUpFiles] = useState(null);

    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [isZoomed, setIsZoomed] = useState(false);
    const [submit, setSubmit] = useState(false);

    const [progress, setProgress] = useState(0);

    const mediaService = new ServiceMedia();

    const handleZoomChange = (shouldZoom) => {
        if (shouldZoom) {
            setIsZoomed(shouldZoom);
        } else {
            setIsZoomed(shouldZoom);
        }
    }

    const handleFileChange = (event) => {
        const selectedFiles = event.target.files;

        for (let i = 0; i < selectedFiles.length; i++) {
            const file = selectedFiles[i];
            const fileExtension = selectedFiles[i]?.type.split("/")[1];

            if (!allowedExtensions.includes(fileExtension)) {
                toast.error("Only .png, .jpeg file format is allowed, please try again!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            } else {
                setProgress(0);
                setUpFiles(file);
            }
        }
    };

    const uploadFiles = () => {
        if (upfiles !== null) {
            setSubmit(true);
            var formDataA = new FormData();
            formDataA.append("path", media.files.fileurl);
            formDataA.append("doc", upfiles);

            var url = `${API_URL}file/replaceFile`;
            var requestHeaders = {
                'Content-type': 'multipart/form-data',
                'Accept': '*/*',
                'Authorization': `bearer ${token}`,
            };

            axios.post(url, formDataA, {
                headers: requestHeaders,
                onUploadProgress: (progressEvent) => {
                    const fileProgress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                    setProgress((prevProgress) => {
                        return fileProgress;
                    });
                },
            }).then((response) => {
                let body = {
                    "uid": media._id,
                    "data": {
                        "files": response.data.data
                    }
                };
                mediaService.updateFooterImage(body, token).then((res) => {
                    setSubmit(false);
                    setIsOpen(false);
                    setUpFiles(null);
                    setProgress(0);
                    toast.success(`File Uploaded`, { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    loadData();
                });
            });
        } else {
            toast.error("Please select one file for upload!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
        }
    }

    const loadData = () => {
        setLoading(true);
        (async function () {
            var doc = await mediaService.getFooterImage({}, token);
            setMedia(doc.data);
            setLoading(false);
        })();
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <div className="w-full h-full py-3 px-3">
            {
                loading && <div className='flex items-center justify-center w-full h-full'>
                    <Lottie animationData={animPage} className="w-40 h-40" loop={true} />
                </div>
            }
            {
                isOpen && <div className='overflow-y-auto overflow-x-hidden z-50 w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
                    <div className='bg-white w-[600px] absolute right-0 h-screen p-[20px]'>
                        <ScrollArea>
                            <div className='px-4'>
                                <div className='flex items-center justify-between text-2xl'>
                                    <h1 className='font-sans font-medium text-gray-900'>New Image</h1>
                                    <span onClick={() => {
                                        setIsOpen(false);
                                        setUpFiles(null);
                                        loadData();
                                    }}><i className="las la-times text-xl text-gray-700 cursor-pointer"></i></span>
                                </div>
                                <hr className='my-4' />
                                <div className="mb-4">
                                    <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                                        <div className="space-y-1 text-center">
                                            <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                                                <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                            <div className="flex text-sm text-gray-600">
                                                <label className="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                                                    <span>Upload a file</span>
                                                    <input type="file" className="sr-only" multiple={true} onChange={handleFileChange} />
                                                </label>
                                                <p className="pl-1">or drag and drop</p>
                                            </div>
                                            <p className="text-xs text-gray-500 text-center">
                                                PNG, JPG up to 12 MB<br />
                                            </p>
                                        </div>
                                    </div>
                                    {
                                        upfiles !== null && <div className="pl-3 pr-4 py-3 text-sm bg-gray-100 rounded border mt-2">
                                            <div className='flex items-center justify-between'>
                                                <div className="w-0 flex-1 flex items-center">
                                                    <img src={URL.createObjectURL(upfiles)} alt="Icon Template" className='w-10 h-10' />
                                                    <span className="ml-2 flex-1 w-0 truncate flex items-center">
                                                        {upfiles.name}&nbsp;
                                                        <i className="las la-link text-gray-400 text-lg"></i>
                                                    </span>
                                                </div>
                                                <div className="ml-4 flex-shrink-0">
                                                    <label className="relative cursor-pointer rounded-md font-medium text-red-600 font-mono" onClick={() => {
                                                        setUpFiles(null)
                                                    }}>
                                                        <span>Remove</span>
                                                    </label>
                                                </div>
                                            </div>
                                            {
                                                progress !== 0 && <div className='w-full bg-gray-300 mt-1' style={{ height: '4px' }}>
                                                    <div style={{ width: `${progress}%`, transitionDuration: `4s` }} className="h-full transition-all bg-green-400"></div>
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                                <div className='w-full'>
                                    <button type="button" className="w-full text-white bg-primeLight hover:bg-prime focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center flex items-center justify-center" disabled={submit} onClick={() => {
                                        uploadFiles();
                                    }}>
                                        {submit && <Lottie animationData={animBtnLoading} className="w-8 h-8" loop={true} />}
                                        {!submit && "UPDATE"}
                                    </button>
                                </div>
                            </div>
                        </ScrollArea>
                    </div>
                </div>
            }
            <ScrollArea>
                <div className="grid grid-cols-12 grid-gap-2">
                    <div className="col-span-12 mt-2">
                        <div class="intro-y flex items-center justify-between h-10">
                            <h2 class="text-2xl font-medium truncate ml-2">
                                Footer Image
                            </h2>
                            <div className='flex z-50'>
                                <button className="py-1 px-3 h-10 rounded-md bg-prime hover:bg-primeLight text-white mr-4" onClick={() => { setIsOpen(true); }}><i className="las la-pen mr-2"></i> Replace Image</button>
                                <TopBar />
                            </div>
                        </div>
                    </div>
                    <hr className='mt-4 col-span-12' />
                    {
                        !loading && <div className='intro-y col-span-4 border rounded-md my-4'>
                            <ControlledZoom isZoomed={isZoomed} onZoomChange={(shouldZoom) => { handleZoomChange(shouldZoom); }}>
                                <img src={media.files.fileurl} alt="item" className='cursor-pointer rounded-md' />
                            </ControlledZoom>
                        </div>
                    }
                </div>
            </ScrollArea>
        </div>
    )
}
